"use strict";

import banner from "../data/banner.js";
import cookie from "../util/cookie";
import links from "../components/links";
import { pushDataLayerBanner } from "../util/pushDataLayer.js";

export default {
  init: () => {
    let url = document.location.href;
    let isMeuVivo = url.indexOf("cliente-especial-meuvivo") > -1;
    let isMovimento = url.search(/movimento=portabilidade/gi) > -1;
    let isCaptive = url.indexOf("cliente-especial-captive") > -1;
    let is29M = url.search(/plano=29M/gi) > -1;
    let is34v2 = url.search(/plano=2_34M/gi) > -1;

    let data = banner.getData();
    let selo = document.querySelector(".banner--selo"),
      gigas = {
        numero: document.querySelector(".banner--gigas--label"),
        plano: document.querySelector(".banner--gigas--plano"),
      },
      app = {
        icon: document.querySelector(".banner--whatsapp--icon"),
        text: document.querySelector(".banner--whatsapp--label"),
      },
      preco = {
        real: document.querySelector(".banner--preco--content--real"),
        centavos: document.querySelector(
          ".banner--preco--content--texto--destaque.centavos"
        ),
        frequencia: document.querySelector(
          ".banner--preco--content--texto--subdestaque.frequencia"
        ),
      },
      button = document.querySelector(".banner--preco--cta--btn");

    gigas.numero.innerHTML = data.double
      ? `${data.doubleredes.giga_full}`
      : `${data.giga_full}`;

    if (data.double) {
      data.doubleredes.dados_plano.map((plano) => {
        gigas.plano.innerHTML += `${plano.titulo} `;
      });
    } else {
      data.dados_plano.map((plano) => {
        // if ((isCaptive && !data.offer && !is34v2)) return

        if (data.offer && plano.titulo_oferta) {
          gigas.plano.innerHTML = `${plano.titulo_oferta} `;
        } else {
          gigas.plano.innerHTML += `${plano.titulo} `;
        }
      });
    }

    if (data.app.fl_apps) {
      document.querySelector(".banner--whatsapp--icon").classList.add("apps");
      document.querySelector(".banner--whatsapp--label").classList.add("apps");
    }

    app.icon.innerHTML = `<img src="${data.app.icone}" alt="${data.app.textoAlternativo}" />`;
    app.text.innerHTML = `${data.app.titulo}`;

    if (isMeuVivo) {
      if (isMovimento) {
        document.querySelector(".banner--selo").textContent =
          "OFERTA EXCLUSIVA";
      } else {
        document.querySelector(".banner--selo").textContent =
          "OFERTA EXCLUSIVA MEU VIVO";
      }
    } else {
      document.querySelector(".banner--selo").textContent =
        "OFERTA EXCLUSIVA DO SITE";
    }

    if (data.selo) {
      selo.classList.add("active");
    }

    preco.real.innerHTML = data.double
      ? `${data.doubleredes.preco.real}`
      : `${data.preco.real}`;
    preco.centavos.innerHTML = data.double
      ? `,${data.doubleredes.preco.centavos}`
      : `,${data.preco.centavos}`;

    let ga = cookie.readCookie("_ga") ? `&_ga=${cookie.readCookie("_ga")}` : "";
    button.setAttribute(
      "href",
      data.link + data.action + "&" + links.getParams() + 'bnr=true' + ga
    );

    const bannerTitle =
      !data.double
        ? data.dados_plano[0].titulo_oferta + ' ' + data.dados_plano[0].titulo
        : data.doubleredes.giga_full + ' ' + data.doubleredes.dados_plano[0].titulo;
    let imgName = data.app.icone.split('/').at(-1);
    imgName = imgName.split('.')[0];

    pushDataLayerBanner({ view: true, id: data.id, bannerTitle, imgName });

    button.addEventListener('click', () => {
      pushDataLayerBanner({ view: false, id: data.id, bannerTitle, imgName });
    });
  },
};
